// LUMINA · pages/vajra/admin/TagsSection.jsx
// Phase 39D: extracted from AdminHub.jsx — 成员标签管理

import React, { useState } from 'react';
import { API, GD, DG, CR, PANEL } from '../constants';

export default function TagsSection({ token, headers, tags, setTags, loadAdminData }) {
  const [newTag, setNewTag] = useState({name:"",color:"#6b7280"});
  const [tagMsg, setTagMsg] = useState("");

  const createTag = async () => {
    if(!newTag.name.trim()) return;
    const r = await fetch(`${API}/vajra/admin/tags`,{method:"POST",headers,body:JSON.stringify(newTag)});
    if(r.ok){ setTagMsg("✓ 标签已创建"); setNewTag({name:"",color:"#6b7280"}); loadAdminData(); }
    else { const d=await r.json(); setTagMsg("✗ "+(d.detail||"失败")); }
  };

  const deleteTag = async (id) => {
    if(!window.confirm("确认删除此标签？")) return;
    await fetch(`${API}/vajra/admin/tags/${id}`,{method:"DELETE",headers});
    loadAdminData();
  };

  return (
    <div style={{background:PANEL,borderRadius:12,padding:"20px",border:`1px solid rgba(0,0,0,0.06)`}}>
      <div style={{fontSize:14,color:GD,marginBottom:16}}>成员标签管理</div>
      {tagMsg&&<div style={{fontSize:13,padding:"8px 14px",borderRadius:8,marginBottom:14,
        background:tagMsg.startsWith("✓")?"rgba(6,78,59,0.06)":"rgba(107,26,26,0.06)",
        color:tagMsg.startsWith("✓")?DG:CR}}>{tagMsg}</div>}
      {/* Create tag */}
      <div style={{display:"flex",gap:8,marginBottom:20,alignItems:"flex-end"}}>
        <div style={{flex:1}}>
          <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>标签名称</label>
          <input value={newTag.name} onChange={e=>setNewTag({...newTag,name:e.target.value})}
            placeholder="例如：初学者、进阶修行、闭关候选"
            style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:14,boxSizing:"border-box"}}/>
        </div>
        <div>
          <label style={{display:"block",fontSize:11,color:"#aaa",marginBottom:4}}>颜色</label>
          <input type="color" value={newTag.color} onChange={e=>setNewTag({...newTag,color:e.target.value})}
            style={{height:38,width:48,border:"1px solid #ddd",borderRadius:7,cursor:"pointer"}}/>
        </div>
        <button onClick={createTag} style={{padding:"9px 18px",background:GD,color:"#fff",border:"none",borderRadius:7,fontSize:13,cursor:"pointer",whiteSpace:"nowrap"}}>
          + 创建标签
        </button>
      </div>
      {/* Tag list */}
      <div style={{fontSize:11,color:"#aaa",letterSpacing:1.2,textTransform:"uppercase",marginBottom:10}}>现有标签 ({tags.length})</div>
      {tags.length===0&&<div style={{fontSize:13,color:"#ccc",textAlign:"center",padding:"16px 0"}}>暂无标签，请先创建</div>}
      <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
        {tags.map(t=>(
          <div key={t.id} style={{display:"flex",alignItems:"center",gap:6,
            padding:"4px 12px 4px 10px",borderRadius:20,border:`1px solid ${t.color}22`,background:`${t.color}18`}}>
            <span style={{width:8,height:8,borderRadius:"50%",background:t.color,flexShrink:0}}/>
            <span style={{fontSize:13,color:"#333"}}>{t.name}</span>
            <span style={{fontSize:11,color:"#999",marginLeft:2}}>({t.member_count}人)</span>
            <button onClick={()=>deleteTag(t.id)} style={{background:"none",border:"none",color:"#ccc",cursor:"pointer",fontSize:14,lineHeight:1,padding:0,marginLeft:4}}>×</button>
          </div>
        ))}
      </div>
    </div>
  );
}
